import { isNil } from 'lodash'
import { unitConverter } from 'utils/unitConverter/unitConverter'

// The inputs are in the user's units (imperial: gal/h, in, ft; metric: L/h, mm, m) and so is the result
// (in/hr or mm/hr), unrounded.
export const getCalculatedApplicationRate = ({
  emitterFlowRate,
  emitterSpacing,
  rowSpacing,
  numberOfLines,
  isImperial,
}: {
  emitterFlowRate: number
  emitterSpacing: number
  rowSpacing: number
  numberOfLines: number
  isImperial: boolean
}): number | null => {
  const litresPerHour = unitConverter
    .emitterFlowRate(emitterFlowRate, { inputUnit: isImperial ? 'gal/h' : 'l/h', outputUnit: 'l/h' })
    .valueWithNoRounding()

  const emitterSpacingMetres = unitConverter
    .emitterSpacing(emitterSpacing, { inputUnit: isImperial ? 'in' : 'mm', outputUnit: 'm' })
    .valueWithNoRounding()

  const rowSpacingMetres = unitConverter
    .rowSpacing(rowSpacing, { inputUnit: isImperial ? 'ft' : 'm', outputUnit: 'm' })
    .valueWithNoRounding()

  if (isNil(litresPerHour) || !emitterSpacingMetres || !rowSpacingMetres) return null

  // A litre spread over a square metre is a millimetre deep.
  const millimetresPerHour = (litresPerHour * numberOfLines) / (emitterSpacingMetres * rowSpacingMetres)

  return unitConverter
    .irrigationApplicationRate(millimetresPerHour, { outputUnit: isImperial ? 'in' : 'mm' })
    .valueWithNoRounding()
}
